/* src/views/accueil/proto/FeuillesComplement.jsx — les QUATRE feuilles
   nouvelles de docs/handoff/accueil-complet.jsx (livré 2026-08-26) : le fil
   de message (avec le bloc opérateur), Mes tâches, Prospection, et le détail
   d'un ménage. LE DESSIN, PAS LA LOGIQUE — styles copiés tels quels, valeurs
   en props, gestes en onXxx. Les data-testid sont ajoutés (attributs), rien
   d'autre. */

import React from 'react'
import { TipRond } from './EcranAccueilProto'

const IcMicro = ({ t }) => (
  <svg width={t} height={t} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="9" y="2" width="6" height="11" rx="3" />
    <path d="M5 10v1a7 7 0 0 0 14 0v-1" /><path d="M12 18v4" />
  </svg>
)

/* ═══ LE FIL DE MESSAGE — feuilleFil du fichier livré ══════════════
   `operateur` = le bloc « L'opérateur propose » : il ne se rend QUE si un
   brouillon RÉEL existe (le copilote IA). Rien n'est inventé à sa place. */
export function FeuilleFilMessage({ resaLigne, onOuvrirResa, bulles = [], operateur,
  canal, reponseRef, onEnvoyer, onMicro, envoiEtat, erreur }) {
  return (
    <>
      {resaLigne && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: '9px 11px',
          background: '#f6f8fa', borderRadius: '11px', marginBottom: '12px' }}>
          <span style={{ flex: '1', minWidth: '0', fontSize: '11.5px',
            color: 'var(--gris)' }}>{resaLigne}</span>
          {onOuvrirResa && (
            <button onClick={onOuvrirResa} data-testid="fil-la-resa" style={{ fontSize: '11px',
              color: 'var(--navy)', padding: '5px' }}>la réservation ›</button>
          )}
        </div>
      )}
      {bulles.map((b, i) => (
        <div key={i} style={{ display: 'flex', gap: '8px', marginBottom: '10px',
          ...(b.deMoi ? { flexDirection: 'row-reverse' } : {}) }}>
          <span style={{ width: '26px', height: '26px', borderRadius: '50%',
            background: b.deMoi ? '#87b8e6' : 'var(--ciel-p)',
            color: b.deMoi ? '#fff' : 'var(--navy)', fontSize: '10px', fontWeight: '600',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: '0' }}>{b.ini}</span>
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block',
              background: b.deMoi ? 'var(--ciel-p)' : '#3d5166',
              color: b.deMoi ? 'var(--navy-d)' : '#fff', borderRadius: '12px',
              padding: '10px 12px', fontSize: '12.5px', lineHeight: '1.6' }}>{b.texte}</span>
            <span style={{ display: 'block', fontSize: '10px', color: 'var(--gris-d)',
              marginTop: '3px', ...(b.deMoi ? { textAlign: 'right' } : {}) }}>{b.quand}</span>
          </span>
        </div>
      ))}
      {operateur && (
        <div data-testid="fil-operateur" style={{ display: 'flex', gap: '8px',
          margin: '0 0 10px 26px', flexDirection: 'row-reverse' }}>
          <button onClick={onMicro} style={{ width: '26px', height: '26px',
            borderRadius: '50%', background: '#87b8e6', color: '#fff', display: 'flex',
            alignItems: 'center', justifyContent: 'center', flexShrink: '0', border: 'none',
            padding: '0', position: 'relative' }}><IcMicro t={13} /></button>
          <span style={{ flex: '1', minWidth: '0' }}>
            <button onClick={onMicro} style={{ display: 'block', width: '100%',
              textAlign: 'right', fontSize: '10px', color: '#5c7d99', fontWeight: '600',
              marginBottom: '3px', background: 'none', border: 'none',
              padding: '0' }}>L'opérateur propose · le relancer</button>
            {operateur.resume && (
              <span style={{ display: 'block', fontSize: '11px', color: 'var(--gris)',
                lineHeight: '1.55', marginBottom: '6px',
                textAlign: 'right' }}>{operateur.resume}</span>
            )}
            <span data-testid="fil-operateur-texte" style={{ display: 'block',
              background: 'var(--ciel-p)', border: '1px dashed #87b8e6', borderRadius: '12px',
              padding: '10px 12px', fontSize: '12.5px', lineHeight: '1.6',
              color: 'var(--navy-d)' }}>{operateur.texte}</span>
            <span style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end',
              marginTop: '7px' }}>
              <button onClick={operateur.onEnvoyer} data-testid="fil-operateur-envoyer"
                style={{ minHeight: '38px', padding: '0 13px', borderRadius: '9px',
                  background: 'var(--terra)', color: '#fff', fontSize: '11.5px',
                  fontWeight: '600' }}>Envoyer</button>
              <button onClick={onMicro} style={{ minHeight: '38px', padding: '0 13px',
                borderRadius: '9px', background: '#fff', border: '1px solid #c3d5e4',
                color: 'var(--navy)', fontSize: '11.5px' }}>Le relancer</button>
              <button onClick={operateur.onEcarter} data-testid="fil-operateur-ecarter"
                style={{ minHeight: '38px', padding: '0 11px', fontSize: '11.5px',
                  color: 'var(--gris)', background: 'none', border: 'none' }}>Écarter</button>
            </span>
          </span>
        </div>
      )}
      <div className="carte" style={{ margin: '12px 0 0' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11.5px',
          color: 'var(--gris)', marginBottom: '9px' }}>
          <span>↩ Répondre par</span>
          <span className="tag t-b">{canal}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '9px' }}>
          <div contentEditable="true" data-testid="fil-reponse" ref={reponseRef}
            suppressContentEditableWarning
            style={{ flex: '1', minWidth: '0', border: '1px solid #d5e3ee',
              borderRadius: '10px', padding: '11px', fontSize: '12.5px',
              color: 'var(--gris-d)', minHeight: '60px', outline: 'none' }} />
          <button onClick={onMicro} data-testid="fil-micro" style={{ border: 'none',
            background: 'none', padding: '0', flexShrink: '0', position: 'relative' }}>
            <span style={{ width: '48px', height: '48px', borderRadius: '50%',
              background: '#87b8e6', color: '#fff', display: 'inline-flex',
              alignItems: 'center', justifyContent: 'center',
              flexShrink: '0' }}><IcMicro t={21} /></span>
          </button>
        </div>
        <div className="act">
          <button className="bt bt-p" data-testid="fil-envoyer" onClick={onEnvoyer}
            disabled={envoiEtat === 'envoi'}>
            {envoiEtat === 'envoi' ? 'Envoi…' : 'Envoyer'}
          </button>
        </div>
      </div>
      {erreur}
    </>
  )
}

/* ═══ MES TÂCHES — la feuille du fichier livré ═════════════════════ */
export function FeuilleTaches({ retard = [], aujourdhui = [], onNouvelle, erreur }) {
  return (
    <>
      {retard.length > 0 && (
        <p className="inter" style={{ marginTop: '0' }}>En retard · {retard.length}</p>
      )}
      {retard.map((t, i) => (
        <div className="ligne" key={`r${i}`}
          style={{ borderColor: 'var(--terra-bd)', background: 'var(--terra-bg)' }}>
          <span className="pc" style={{ background: 'var(--terra)', color: '#fff' }}>!</span>
          <span className="co">
            <span className="t">{t.titre}</span>
            <span className="s" style={{ color: 'var(--terra-tx)' }}>{t.sous}</span>
          </span>
        </div>
      ))}
      {aujourdhui.length > 0 && (
        <p className="inter" style={retard.length === 0 ? { marginTop: '0' } : undefined}>
          Aujourd'hui · {aujourdhui.length}</p>
      )}
      {aujourdhui.map((t, i) => (
        <div className="ligne" key={`a${i}`}>
          <span className="pc">☑</span>
          <span className="co">
            <span className="t">{t.titre}</span>
            <span className="s">{t.sous}</span>
          </span>
        </div>
      ))}
      <div className="act">
        <button className="bt bt-p" data-testid="taches-nouvelle"
          onClick={onNouvelle}>＋ Nouvelle tâche</button>
      </div>
      {erreur}
    </>
  )
}

/* ═══ PROSPECTION — la feuille du fichier livré ════════════════════ */
export function FeuilleProspects({ info, lignes = [], note, erreur }) {
  return (
    <>
      <div className="info">{info}</div>
      {lignes.length > 0 && <p className="inter" style={{ marginTop: '0' }}>Les mieux notés</p>}
      {lignes.map((l, i) => (
        <button className="ligne" key={i} data-testid={`prospect-${i}`}
          onClick={l.onOuvrir}>
          <span className="pc" style={{ background: 'var(--ciel-p)', color: 'var(--navy)',
            fontWeight: '600', fontSize: '11px' }}>{l.score}</span>
          <span className="co">
            <span className="t">{l.titre}</span>
            <span className="s">{l.sous}</span>
          </span>
          <span className="ch">↗</span>
        </button>
      ))}
      <p className="note">{note}</p>
      {erreur}
    </>
  )
}

/* ═══ LE DÉTAIL D'UN MÉNAGE — la feuille du fichier livré ══════════ */
export function FeuilleMenageDetail({ agent, heures, boutons, checklist, erreur }) {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: '9px', marginBottom: '11px' }}>
        <span className="pc" style={{ width: '34px', height: '34px', borderRadius: '9px',
          background: 'var(--ciel-p)', color: 'var(--navy)', display: 'flex',
          alignItems: 'center', justifyContent: 'center', fontSize: '12px',
          fontWeight: '600' }}>{agent.ini}</span>
        <span style={{ flex: '1', minWidth: '0' }}>
          <span style={{ display: 'block', fontSize: '12.5px',
            fontWeight: '600' }}>{agent.nom}</span>
          <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
            marginTop: '1px' }}>{agent.sous}</span>
        </span>
        {agent.tip && <TipRond variante={agent.tip} />}
      </div>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '9px' }}>
        {heures.departSure ? (
          <div style={{ flex: '1', minWidth: '0', borderRadius: '12px', padding: '10px 12px',
            background: '#87b8e6' }}>
            <span style={{ display: 'block', fontSize: '10px',
              color: 'rgba(255,255,255,.8)' }}>Départ du voyageur</span>
            <span style={{ display: 'block', fontSize: '21px', fontWeight: '600',
              lineHeight: '1.15', marginTop: '2px', color: '#fff' }}>{heures.departH}</span>
            <span style={{ display: 'block', fontSize: '9.5px', marginTop: '1px',
              color: 'rgba(255,255,255,.75)' }}>annoncé dans le formulaire</span>
          </div>
        ) : (
          <div style={{ flex: '1', minWidth: '0', borderRadius: '12px', padding: '10px 12px',
            background: '#eaeff4', border: '1px dashed #c3cdd6' }}>
            <span style={{ display: 'block', fontSize: '10px',
              color: 'var(--gris)' }}>Départ du voyageur</span>
            <span style={{ display: 'block', fontSize: '21px', fontWeight: '600',
              lineHeight: '1.15', marginTop: '2px', color: 'var(--gris)' }}>{heures.departH}</span>
            <span style={{ display: 'block', fontSize: '9.5px', marginTop: '1px',
              color: 'var(--gris-d)' }}>heure du contrat</span>
          </div>
        )}
        {heures.arriveeSure ? (
          <div style={{ flex: '1', minWidth: '0', borderRadius: '12px', padding: '10px 12px',
            background: '#87b8e6' }}>
            <span style={{ display: 'block', fontSize: '10px',
              color: 'rgba(255,255,255,.8)' }}>Arrivée du suivant</span>
            <span style={{ display: 'block', fontSize: '21px', fontWeight: '600',
              lineHeight: '1.15', marginTop: '2px', color: '#fff' }}>{heures.arriveeH}</span>
            <span style={{ display: 'block', fontSize: '9.5px', marginTop: '1px',
              color: 'rgba(255,255,255,.75)' }}>annoncé dans le formulaire</span>
          </div>
        ) : (
          <div style={{ flex: '1', minWidth: '0', borderRadius: '12px', padding: '10px 12px',
            background: '#eaeff4', border: '1px dashed #c3cdd6' }}>
            <span style={{ display: 'block', fontSize: '10px',
              color: 'var(--gris)' }}>Arrivée du suivant</span>
            <span style={{ display: 'block', fontSize: '21px', fontWeight: '600',
              lineHeight: '1.15', marginTop: '2px', color: 'var(--gris)' }}>{heures.arriveeH}</span>
            <span style={{ display: 'block', fontSize: '9.5px', marginTop: '1px',
              color: 'var(--gris-d)' }}>heure du contrat</span>
          </div>
        )}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px',
        marginTop: '2px' }}>
        <button onClick={boutons.onCodes} data-testid="menage-detail-codes"
          style={{ display: 'flex', alignItems: 'center', gap: '9px', textAlign: 'left',
            background: '#fff', border: '1px solid var(--bord)', borderRadius: '12px',
            padding: '10px 11px', minHeight: '56px' }}>
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600' }}>Les codes</span>
            <span style={{ display: 'block', fontSize: '10px', color: 'var(--gris)',
              marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis',
              whiteSpace: 'nowrap' }}>{boutons.codesSous}</span>
          </span>
          <span style={{ fontSize: '15px', color: 'var(--gris-d)' }}>›</span>
        </button>
        <button onClick={boutons.onControler} data-testid="menage-detail-controler"
          style={{ display: 'flex', alignItems: 'center', gap: '9px', textAlign: 'left',
            background: '#fff', border: '1px solid var(--bord)', borderRadius: '12px',
            padding: '10px 11px', minHeight: '56px' }}>
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600' }}>Contrôler</span>
            <span style={{ display: 'block', fontSize: '10px', color: 'var(--gris)',
              marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis',
              whiteSpace: 'nowrap' }}>{boutons.controlerSous}</span>
          </span>
          {boutons.controlerTip && <TipRond variante={boutons.controlerTip} />}
        </button>
        <button onClick={boutons.onIncidents} data-testid="menage-detail-incidents"
          style={{ display: 'flex', alignItems: 'center', gap: '9px', textAlign: 'left',
            background: '#fff', border: '1px solid var(--bord)', borderRadius: '12px',
            padding: '10px 11px', minHeight: '56px' }}>
          <span style={{ flex: '1', minWidth: '0' }}>
            <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600' }}>Incidents</span>
            <span style={{ display: 'block', fontSize: '10px', color: 'var(--gris)',
              marginTop: '1px', overflow: 'hidden', textOverflow: 'ellipsis',
              whiteSpace: 'nowrap' }}>{boutons.incidentsSous}</span>
          </span>
          {boutons.incidentsTip && <TipRond variante={boutons.incidentsTip} />}
        </button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '16px 0 9px' }}>
        <span style={{ width: '24px', height: '24px', borderRadius: '7px',
          background: '#4a9d7a', color: '#fff', display: 'flex', alignItems: 'center',
          justifyContent: 'center', flexShrink: '0' }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </span>
        <span style={{ fontSize: '11.5px', fontWeight: '600',
          color: 'var(--vert-tx)' }}>La checklist et ses photos</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
        <span style={{ flex: '1', fontSize: '12.5px', fontWeight: '600' }}>{checklist.titre}</span>
        <span style={{ fontSize: '10.5px', color: 'var(--gris)' }}>{checklist.photosLabel}</span>
      </div>
      <div style={{ display: 'flex', gap: '9px', overflowX: 'auto',
        scrollSnapType: 'x mandatory', scrollbarWidth: 'none', paddingBottom: '4px',
        margin: '0 -14px', paddingLeft: '14px', paddingRight: '14px', touchAction: 'pan-x',
        overscrollBehaviorX: 'contain', WebkitOverflowScrolling: 'touch' }}>
        {checklist.pieces.map((p, i) => (
          <div key={i} style={{ flex: '0 0 200px', scrollSnapAlign: 'start',
            background: '#fff', border: '1px solid var(--bord)', borderRadius: '12px',
            padding: '11px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px',
              marginBottom: '9px' }}>
              <span style={{ flex: '1', fontSize: '12.5px', fontWeight: '600' }}>{p.nom}</span>
              <span style={{ fontSize: '10.5px', color: 'var(--gris)' }}>{p.lignes}</span>
              {p.tip && <TipRond variante={p.tip} />}
            </div>
            {p.photos && p.photos.length > 0 ? (
              <div style={{ display: 'flex', gap: '6px' }}>
                {p.photos.map((ph, j) => (
                  <button key={j} onClick={() => checklist.onPhoto(ph)}
                    data-testid={`menage-detail-photo-${i}-${j}`}
                    style={{ flex: '1', height: '104px', borderRadius: '9px',
                      background: '#e6eaee', border: '1px solid var(--bord)',
                      color: '#98a2ad', fontSize: '18px',
                      ...(typeof ph === 'string' && ph !== '◫'
                        ? { backgroundImage: `url(${ph})`, backgroundSize: 'cover',
                            backgroundPosition: 'center' } : {}) }}>
                    {typeof ph === 'string' && ph !== '◫' ? '' : '◫'}
                  </button>
                ))}
              </div>
            ) : (
              <div style={{ height: '104px', borderRadius: '9px',
                border: '1px dashed #c3d5e4', background: '#f8fafc', display: 'flex',
                alignItems: 'center', justifyContent: 'center', fontSize: '10.5px',
                color: 'var(--gris-d)', textAlign: 'center',
                padding: '0 10px' }}>Aucune photo demandée pour cette pièce</div>
            )}
          </div>
        ))}
      </div>
      <p className="note">Faites glisser pour passer d'une pièce à l'autre.</p>
      {erreur}
    </>
  )
}
